import { ExtractModel } from "../../models/ExtractModel";
import { QueryListAction } from '../../../pillar/dashboard/store/actions/QueryListAction';
import { ExtractListModel } from '../../models/ExtractListModel';
import { CalOmsExtractWorkspaceFilterModel } from '../../models/CalOmsExtractWorkspaceFilterModel';

export const GET_EXTRACT_LIST_ACTION = '[Extracts] Get Extract List Action';

export class GetExtractListAction extends QueryListAction<ExtractListModel> {
  constructor(module: string, modelType: { new(): ExtractListModel; }, public payload: {
    page: number,
    pageSize: number,
    sort?: string,
    sortDirection?: string,
    searchTerm?: string,
    model?: ExtractModel,
    filterModel?: CalOmsExtractWorkspaceFilterModel,
  }) {
    super(module, modelType, payload);
  }
}



// WEBPACK FOOTER //
// ./src/app/extracts/store/actions/GetExtractListAction.ts